@if (viewConfig.loading) {
<app-spinner-fullscreen></app-spinner-fullscreen>
} @else if (viewConfig.error) {
<ngb-alert (closed)="viewConfig.setDefault()" type="danger">{{
  viewConfig.error
}}</ngb-alert>
}
<ng-template #content let-modal>
  <div class="modal-header">
    <div
      [attr.aria-label]="getAddUserHeader()"
      class="modal-title"
      id="modal-basic-title"
      role="heading"
      aria-level="2"
    >
      {{ getAddUserHeader() }}
    </div>
    <button
      addAaTags="Close popup"
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
      (keydown.enter)="modal.dismiss('Cross click')"
      (keydown.space)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <form
    novalidate
    [formGroup]="createUserForm"
    (ngSubmit)="onCreateUser()"
    role="form"
  >
    <div class="modal-body container">
      <div class="row">
        @if (createUserViewConfig.error) {
        <div class="col-md-12">
          <ngb-alert
            (closed)="createUserViewConfig.setDefault()"
            type="danger"
            >{{ createUserViewConfig.error }}</ngb-alert
          >
        </div>
        }
        <div class="col-md-6 mb-3">
          <label for="firstName"
            >First Name
            <span class="text-danger" aria-hidden="true">*</span></label
          >
          <input
            id="firstName"
            class="form-control"
            formControlName="firstName"
            required
            [attr.aria-invalid]="
              createUserFormSubmitted && userForm['firstName'].errors
                ? 'true'
                : 'false'
            "
            [attr.aria-describedby]="
              createUserFormSubmitted && userForm['firstName'].errors
                ? 'create-user-firstname-error'
                : null
            "
            [ngClass]="{
              'is-invalid':
                createUserFormSubmitted && userForm['firstName'].errors
            }"
          />
          @if (createUserFormSubmitted && userForm['firstName'].errors) {
          <div
            id="create-user-firstname-error"
            class="invalid-feedback"
            role="alert"
          >
            @if (userForm['firstName'].errors['required'] ||
            userForm['firstName'].errors['whitespace']) {
            <div>This field is required</div>
            }
          </div>
          }
        </div>
        <div class="col-md-6 mb-3">
          <label for="lastName"
            >Last Name
            <span class="text-danger" aria-hidden="true">*</span></label
          >
          <input
            id="lastName"
            class="form-control"
            formControlName="lastName"
            required
            [attr.aria-invalid]="
              createUserFormSubmitted && userForm['lastName'].errors
                ? 'true'
                : 'false'
            "
            [attr.aria-describedby]="
              createUserFormSubmitted && userForm['lastName'].errors
                ? 'create-user-lastname-error'
                : null
            "
            [ngClass]="{
              'is-invalid':
                createUserFormSubmitted && userForm['lastName'].errors
            }"
          />
          @if (createUserFormSubmitted && userForm['lastName'].errors) {
          <div
            id="create-user-lastname-error"
            class="invalid-feedback"
            role="alert"
          >
            @if (userForm['lastName'].errors['required'] ||
            userForm['lastName'].errors['whitespace']) {
            <div>This field is required</div>
            }
          </div>
          }
        </div>
      </div>
      @if (!selectedUser.id) {
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="email"
            >Email
            <span class="text-danger" aria-hidden="true">*</span></label
          >
          <input
            id="email"
            type="email"
            class="form-control"
            formControlName="email"
            required
            [attr.aria-invalid]="
              createUserFormSubmitted && userForm['email'].errors
                ? 'true'
                : 'false'
            "
            [attr.aria-describedby]="
              createUserFormSubmitted && userForm['email'].errors
                ? 'create-user-email-error'
                : null
            "
            [ngClass]="{
              'is-invalid': createUserFormSubmitted && userForm['email'].errors
            }"
          />
          @if (createUserFormSubmitted && userForm['email'].errors) {
          <div
            id="create-user-email-error"
            class="invalid-feedback"
            role="alert"
          >
            @if (userForm['email'].errors['required'] ||
            userForm['email'].errors['whitespace']) {
            <div>This field is required</div>
            } @else if (userForm['email'].errors['email']) {
            <div>Enter a valid email address</div>
            }
          </div>
          }
        </div>
        <div class="col-md-6 mb-3">
          <label for="role"
            >Role
            <span class="text-danger" aria-hidden="true">*</span></label
          >
          <select
            class="form-select"
            id="role"
            formControlName="role"
            required
            [attr.aria-invalid]="
              createUserFormSubmitted && userForm['role'].errors
                ? 'true'
                : 'false'
            "
            [attr.aria-describedby]="
              createUserFormSubmitted && userForm['role'].errors
                ? 'create-user-role-error'
                : null
            "
            [ngClass]="{
              'is-invalid': createUserFormSubmitted && userForm['role'].errors
            }"
          >
            <option [value]="userRoleEnum.ADMIN">
              {{ getRoleDisplayName(userRoleEnum.ADMIN) }}
            </option>
            <option [value]="userRoleEnum.USER">
              {{ getRoleDisplayName(userRoleEnum.USER) }}
            </option>
          </select>
          @if (createUserFormSubmitted && userForm['role'].errors) {
          <div
            id="create-user-role-error"
            class="invalid-feedback"
            role="alert"
          >
            @if (userForm['role'].errors['required'] ||
            userForm['role'].errors['whitespace']) {
            <div>This field is required</div>
            }
          </div>
          }
        </div>
      </div>
      }
    </div>
    <div class="modal-footer">
      <app-button
        (click)="$event.preventDefault(); modal.dismiss('cancel click')"
        (keydown.enter)="$event.preventDefault(); modal.dismiss('cancel click')"
        (keydown.space)="$event.preventDefault(); modal.dismiss('cancel click')"
        type="outline-dark"
        class="ind-button-md"
        label="Cancel"
      ></app-button>
      <app-button
        [disabled]="hasEmailError()"
        type="primary"
        class="ind-button-md"
        [label]="getSaveButtonText()"
      ></app-button>
    </div>
  </form>
</ng-template>
<!-- LIST USER -->
<div class="row" role="none">
  <div class="col-12 p-0">
    <div uid="main" class="table-responsive-sm">
      <table class="table ind-table table-hover" role="table">
        <thead class="ind-table-thead">
          <tr>
            <th scope="col">First Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Email</th>
            <th scope="col">Role</th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (user of users; track user; let index = $index) {
          <tr>
            <td>{{ user.firstName }}</td>
            <td>{{ user.lastName }}</td>
            <td>{{ user.email }}</td>
            <td class="w-25">{{ getRole(user.customClaims) }}</td>
            <td>
              @if (!user.disabled) {
              <a
                [attr.aria-label]="'Active'"
                href="javascript:void(0);"
                class="active-user link-underline-opacity-0 link-underline-opacity-0-hover"
                (click)="activateOrInactivate(false, user.uid)"
                (keydown.enter)="activateOrInactivate(false, user.uid)"
                (keydown.space)="activateOrInactivate(false, user.uid)"
                >Active</a
              >
              } @else {
              <a
                [attr.aria-label]="'Deactivated'"
                href="javascript:void(0);"
                class="deactive-user link-underline-opacity-0 link-underline-opacity-0-hover"
                (click)="activateOrInactivate(true, user.uid)"
                (keydown.enter)="activateOrInactivate(true, user.uid)"
                (keydown.space)="activateOrInactivate(true, user.uid)"
                >Deactivated</a
              >
              }
            </td>
            <td>
              <div
                class="collapse navbar-collapse justify-content-end"
                [ngbCollapse]="user.isNavbarCollapsed"
                [id]="'navbarSupportedContent' + index"
              >
                <ul class="navbar-nav mb-2 mb-lg-0">
                  <li
                    [attr.aria-label]=""
                    class="nav-item dropdown"
                    ngbDropdown
                    display="dynamic"
                    #actionsDropdown="ngbDropdown"
                    (openChange)="onActionMenuOpen($event, index)"
                  >
                    <button
                      type="button"
                      class="nav-link dropdown-toggle btn btn-link p-0 action-menu-toggle"
                      ngbDropdownToggle
                      id="navbarDropdown"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      [attr.aria-expanded]="actionsDropdown.isOpen()"
                      [attr.aria-label]="
                        'Actions menu for ' + user.firstName + ' ' + user.lastName
                      "
                      (keydown.enter)="actionsDropdown.toggle()"
                      (keydown.space)="actionsDropdown.toggle(); $event.preventDefault()"
                    >
                      <img
                        [addAaTags]="
                          user.firstName + ' ' + user.lastName + ' User Action'
                        "
                        src="/icons/linear/menu.svg"
                      />
                    </button>
                    <div
                      ngbDropdownMenu
                      class="dropdown-menu"
                      role="menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <button
                        type="button"
                        [attr.id]="'action-menu-first-' + index"
                        role="menuitem"
                        [attr.aria-label]= "'Reset Password'"
                        [attr.aria-posinset]="1"
                        [attr.aria-setsize]="5"
                        ngbDropdownItem
                        (click)="openResetPasswordModal(user.uid, user.email)"
                        (keydown.enter)="$event.preventDefault(); openResetPasswordModal(user.uid, user.email); actionsDropdown.close()"
                        (keydown.space)="$event.preventDefault(); openResetPasswordModal(user.uid, user.email); actionsDropdown.close()"
                        class="dropdown-item"
                      >
                        Reset Password
                      </button>
                      <button
                        type="button"
                        role="menuitem"
                        [attr.aria-label]="
                          'Edit User'
                        "
                        [attr.aria-posinset]="2"
                        [attr.aria-setsize]="5"
                        ngbDropdownItem
                        (click)="edit(user)"
                        (keydown.enter)="$event.preventDefault(); edit(user); actionsDropdown.close()"
                        (keydown.space)="$event.preventDefault(); edit(user); actionsDropdown.close()"
                        class="dropdown-item"
                      >
                        Edit User
                      </button>
                      <button
                        type="button"
                        role="menuitem"
                        [attr.aria-label]="
                          'Reset OTP '
                        "
                        [attr.aria-posinset]="3"
                        [attr.aria-setsize]="5"
                        ngbDropdownItem
                        (click)="resetMfa(user)"
                        (keydown.enter)="$event.preventDefault(); resetMfa(user); actionsDropdown.close()"
                        (keydown.space)="$event.preventDefault(); resetMfa(user); actionsDropdown.close()"
                        class="dropdown-item"
                      >
                        Reset OTP
                      </button>
                      @if (user.disabled) {
                      <button
                        type="button"
                        role="menuitem"
                        [attr.aria-label]="
                          'Activate User '
                        "
                        [attr.aria-posinset]="4"
                        [attr.aria-setsize]="5"
                        ngbDropdownItem
                        class="dropdown-item"
                        (click)="activateOrInactivate(true, user.uid)"
                        (keydown.enter)="$event.preventDefault(); activateOrInactivate(true, user.uid); actionsDropdown.close()"
                        (keydown.space)="$event.preventDefault(); activateOrInactivate(true, user.uid); actionsDropdown.close()"
                      >
                        Activate User
                      </button>
                      } @else {
                      <button
                        type="button"
                        role="menuitem"
                        [attr.aria-label]="
                          'Deactivate User '
                        "
                        [attr.aria-posinset]="4"
                        [attr.aria-setsize]="5"
                        ngbDropdownItem
                        class="dropdown-item"
                        (click)="activateOrInactivate(false, user.uid)"
                        (keydown.enter)="$event.preventDefault(); activateOrInactivate(false, user.uid); actionsDropdown.close()"
                        (keydown.space)="$event.preventDefault(); activateOrInactivate(false, user.uid); actionsDropdown.close()"
                      >
                        Deactivate User
                      </button>
                      } @if (!user.customClaims?.admin) {
                      <button
                        type="button"
                        role="menuitem"
                        [attr.aria-label]="
                          'Change to Admin User'"
                        [attr.aria-posinset]="5"
                        [attr.aria-setsize]="5"
                        ngbDropdownItem
                        (click)="makeAdmin(user.uid)"
                        (keydown.enter)="$event.preventDefault(); makeAdmin(user.uid); actionsDropdown.close()"
                        (keydown.space)="$event.preventDefault(); makeAdmin(user.uid); actionsDropdown.close()"
                        class="dropdown-item"
                      >
                        Change to "Admin" User
                      </button>
                      } @else {
                      <button
                        type="button"
                        role="menuitem"
                        [attr.aria-label]="
                          'Change to Staff User for ' +
                          user.firstName +
                          ' ' +
                          user.lastName
                        "
                        [attr.aria-posinset]="5"
                        [attr.aria-setsize]="5"
                        ngbDropdownItem
                        (click)="makeStaffUser(user.uid)"
                        (keydown.enter)="$event.preventDefault(); makeStaffUser(user.uid); actionsDropdown.close()"
                        (keydown.space)="$event.preventDefault(); makeStaffUser(user.uid); actionsDropdown.close()"
                        class="dropdown-item"
                      >
                        Change to "Staff" User
                      </button>
                      }
                    </div>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="user-count">
      <p>
        Total Users: <b>{{ users.length }}</b>
      </p>
    </div>
  </div>
</div>
